import { apiSlice } from "core/api";
import { makeCrudEndpoints } from "common/api/apiHelpers";
import { Place } from "place/types/place.model";

const api = apiSlice.injectEndpoints({
  endpoints: makeCrudEndpoints<"Place", Place>("Place", "places"),
});

export const {
  useGetPlaceQuery,
  useListPlacesQuery,
  useAddPlaceMutation,
  useRemovePlaceMutation,
  useUpdatePlaceMutation,
} = api;
